// projectFlag：topページのフロジェクト並び替え
export default function projectFlag() {
  // 全プロジェクトを配列に格納
  var project_item_dom = [];
  $('.js-projectItem  > li').each(function (index) {
    project_item_dom.push($(this)[0].outerHTML);
  });

  var item_num = project_item_dom.length;
  var append_html = '';

  // 並び調整
  if (item_num <= 6) {
    item_block(0, 6);
  } else if (item_num <= 8) {
    item_block(0, 4);
    item_block(4, 8);
  } else if (item_num <= 10) {
    item_block(0, 5);
    item_block(5, 10);
  } else if (item_num <= 12) {
    item_block(0, 6);
    item_block(6, 12);
  } else if (item_num <= 15) {
    item_block(0, 5);
    item_block(5, 10);
    item_block(10, 15);
  } else {
    item_block(0, 18);
  }

  // DOM挿入
  $('.js-pickupProject').html(append_html);

  // DOM生成関数
  function item_block(startNum,endNum) {
    var offset_num = startNum;
    var append_html_parts = '';
    for (var index = startNum; index < endNum; index++) {
      if (project_item_dom[index]) {
        append_html_parts += project_item_dom[index];
      }
    }
    append_html += '<ul class="top-project_item">' + append_html_parts+ '</ul>';
  }

}


// WEBPACK FOOTER //
// ./js/module/projectFlag.js